module.exports = __webpack_public_path__ + "files/9438f2c6944f275a801c1eb60da6b59b.png";